import LocalPharmacyIcon from '@mui/icons-material/LocalPharmacy'
import MapIcon from '@mui/icons-material/Map'

/**
 * Routes COMMUNES a tous les membres d'un espace groupement / chaine (managers, delegues,
 * managers de zone), quelle que soit l'entite qui les porte. Les pages de GESTION (equipe,
 * listes d'adherents, zones, laboratoires partenaires, activation de services) vivent dans
 * le getter MANAGER de l'entite Group.
 */

export const routeFrontOfficeAllEntityGroupementChainCommon = [
  {
    route: 'MapsList',
    text: 'Cartes des pharmacies',
    href: '/industryoffice/groupement-chain/maps',
    t: 'routes.frontoffice.group.mapsList',
    icon: MapIcon,
    menuHeader: true,
    home: true,
    position: 200,
  },
  {
    // Niveau 0 du menu, juste apres « Cartes des pharmacies » (demande du 05/09/2026) : les
    // deux entrees du parc sont a plat, pas dans la section « Mon groupement ».
    // « Pharmacies autour de moi » n'est pas une page : c'est le bouton du header, de la
    // liste et de la carte (mode geolocalise).
    route: 'PharmaciesList',
    text: 'Liste des pharmacies',
    t: 'routes.frontoffice.group.pharmaciesList',
    href: '/industryoffice/groupement-chain/pharmacy',
    icon: LocalPharmacyIcon,
    menuHeader: true,
    menuFlat: true,
    position: 210,
  },
  {
    route: 'editCompany',
    text: 'Edition établissement',
    href: '/backoffice/common/company/edit-company/[companyId]',
  },
  {
    route: 'editUser',
    text: "Editer un membre de l'équipe",
    t: 'routes.frontoffice.all.teamUserEdit',
    href: '/frontoffice/group/user-team/edit-user-team/[userId]',
  },
  {
    route: 'MyProfile',
    text: 'Mon profil',
    t: 'routes.frontoffice.group.myProfile',
    href: '/backoffice/common/my-profile',
    menuHeader: false,
  },
]
